import React, { ReactNode } from 'react';

const baseStyles = 'text-28 text-rp-primary font-rp-pn-semi-bold font-medium tracking-wide';

type Props = {
  children: ReactNode;
  classes?: string;
};

const defaultProps = {
  classes: '',
};

export default function SectionTitle({ children, classes }: Props) {
  return <h2 className={`${classes} ${baseStyles}`}>{children}</h2>;
}

SectionTitle.defaultProps = defaultProps;
